import $ from "jquery";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ReactComponent as CloseBtn } from "../../../../assets/icons/close.svg";
import PostLoginGetApi from "../../../../components/Api/PostLoginGetApi";
import PostLoginPostApi from "../../../../components/Api/PostLoginPostApi";
import BlackButton from "../../../../components/BlackButton";
import UserBasicInfoContext from "../../../../components/Context/UserBasicInfoContext";
import init from "../../AccessControl/Check";
import { ReactComponent as PlusIcon } from "./../../../../assets/icons/u_plus.svg";

const StoreItemsDetails = () => {
  const pageName = "Store Item Details";
  const isAccess = init(pageName);

  const [addons, setAddons] = useState([]);
  const [itemDetails, setItemDetails] = useState();
  let { state } = useLocation();
  const [isLoad, setIsLoad] = useState(false);

  const navigate = useNavigate();

  const userProfile = useContext(UserBasicInfoContext);

  useEffect(() => {
    try {
      PostLoginGetApi(`item/${state.itemId}`, "", 2)
        .then((responseJSON) => {
          let response = JSON.stringify(responseJSON);
          response = JSON.parse(response);

          if (response["status"] === 1) {
            let responseData = JSON.stringify(response["data"]);
            responseData = JSON.parse(responseData);

            if (responseData["code"] === 200) {
              setItemDetails(responseData["data"]);
              setIsLoad(true);

              let data = JSON.stringify(responseData["data"]["addons"]) ?? [];
              if( data?.length > 5 ) {
                data = JSON.parse(data, true);
              }

              setAddons(data);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (ex) {
      console.log(ex);
    }
  }, []);

  const handlePublish = () => {
    // Call Request for publish item

    PostLoginPostApi(
      `item/publish-request/${state.itemId}`,
      JSON.stringify({ publish: "active" }),
      1
    )
      .then((responseJSON) => {
        let response = JSON.stringify(responseJSON);
        response = JSON.parse(response);

        if (response["status"] === 1) {
          let responseData = JSON.stringify(response["data"]);
          responseData = JSON.parse(responseData);

          if (responseData["code"] === 200) {
            $("#publish-btn").hide();
            toast.success(responseData["messages"].toString());
            return;
          }

          toast.error(responseData["messages"].toString());
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  if (isAccess === false) {
    return (
      <>
        <table className="custom-details-table w-full mt-0 mb-2">
          <tbody>
            <tr>
              <td className="font-semibold text-base">
                You do not have any access !
              </td>
            </tr>
          </tbody>
        </table>
      </>
    );
  }

  return (
    <>
      {isLoad === true && (
        <div className="h-full">
          <header className="p-4 border-b-2 border-dark-white mb-[60px]">
            <Link to="/dashboard/store" state={{ from: state }}>
              <CloseBtn className="float-left" />
            </Link>
            <p className="text-center text-xl font-medium">Item Details </p>
          </header>
          <div className="max-w-3xl m-auto">
            <div className=" text-[#444444] mb-[30px] ">
              <div>
                <div className="block w-full">
                  <h3 className="text-2xl font-semibold text-[#222222] mb-2.5">
                    {itemDetails.name}
                  </h3>

                  <div className="inline-block w-full">
                    <img
                      className="w-[200px] max-h-[200px] mr-[30px] object-contain float-left"
                      src={itemDetails.image}
                      alt="Item"
                    />
                    <span className="text-justify">
                      {itemDetails.description}
                    </span>
                    <p className="mb-2.5">{itemDetails.category?.name}</p>
                    <p className="mb-2.5">{itemDetails.global_category.name}</p>
                  </div>


                  <div className="mt-5">
                    <h4 className="text-lg text-[#222222] my-2 font-semibold">More Images</h4>
                    {itemDetails.more_images && (
                      <div className="flex">
                        {itemDetails.more_images.map((val, i) => {
                          return (
                            <img
                              src={val}
                              key={i}
                              alt="Text"
                              style={{ width: "80px", padding: "5px" }}
                            />
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>

                <div className="mb-10 block w-full">

                  <h4 className="text-xl text-[#222222] mt-5 mb-5 font-semibold">
                    Unit Price (MRP) :{" "}
                    <span className="font-medium pl-3">
                      {itemDetails.unit_price}
                    </span>{" "}
                  </h4>


                  {itemDetails.trade_price && (
                      <h4 className="text-xl text-[#222222] mt-5 mb-5 font-semibold">
                        Trade Price :
                        <span className="font-medium pl-3">
                        {itemDetails.trade_price}
                      </span>
                      </h4>
                  )}

                  {Object.keys(itemDetails.global_category).length > 0 &&
                  <div className="relative overflow-x-auto shadow-md sm:rounded-lg my-3">
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                      <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                      <tr>
                        <th className="px-6 py-3" colSpan='4'>
                          <h4 className="text-xl font-semibold mb-[10px] mt-2">
                            Specifications
                          </h4>
                        </th>
                      </tr>
                      <tr>
                        <th scope="col" className="px-6 py-3">
                          Attribute
                        </th>
                        <th scope="col" className="px-6 py-3">

                        </th>
                        <th scope="col" className="px-6 py-3 text-center">
                          Value
                        </th>
                        <th scope="col" className="px-6 py-3 text-center">
                          Unit
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      {itemDetails.global_category.spec_attributes_items.map((option, index) =>
                      <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                        <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          {option.attribute_name}
                        </th>
                        <td className="px-6 py-4">
                          :
                        </td>
                        <td className='text-center'>
                          {option.selected ? (option.selected.value !== 'Other' ? option.selected.value : 'XXX'):'Not Mentioned'}
                        </td>
                        <td className="text-center">
                          {option.unit}
                        </td>
                      </tr>
                      )}
                      </tbody>
                    </table>
                  </div>
                  }


                  <div className='border border-1 rounded-xl p-3 shadow-md'>
                  <h4 className="text-xl font-semibold mb-[10px] mt-2">
                    Delivery Information
                  </h4>

                  <div className='flex justify-between border border-1 p-3 rounded-xl'>
                  <p className="mb-2.5">
                    <span className='font-semibold'>Inside Dhaka</span>
                    <p>Charge : {process.env.REACT_APP_CURRENCY_SYMBOL} {itemDetails.delivery?.charge_inside}</p>
                    <p>Days : {itemDetails.delivery?.time_inside ?? "-"}</p>
                  </p>

                    <p className="mb-2.5">
                      <span className='font-semibold'>Outside Dhaka</span>
                      <p>Charge : {process.env.REACT_APP_CURRENCY_SYMBOL} {itemDetails.delivery?.charge_outside}</p>
                      <p>Days : {itemDetails.delivery?.time_outside_start_range} - {itemDetails.delivery?.time_outside_end_range} </p>
                    </p>
                  </div>

                  {(itemDetails.delivery?.note) &&
                    <p className="my-2.5 ">
                      <span className='font-semibold'>Delivery Note :</span> {itemDetails.delivery?.note}
                    </p>
                  }

                  </div>

                  <br/>
                  <h4 className="text-xl font-semibold mb-[10px] mt-2">
                    Other Information
                  </h4>
                  <p className="mb-2.5">
                    Created :{" "}
                    {moment(itemDetails.created_at).format(
                        "DD MMMM, YYYY hh:mm A"
                    )}
                  </p>
                  <p className="mb-2.5">
                    Updated :{" "}
                    {moment(itemDetails.updated_at).format(
                        "DD MMMM, YYYY hh:mm A"
                    )}
                  </p>
                  <p className="mb-2.5">SKU : {itemDetails.sku}</p>
                  {itemDetails.url && <p>Item URL : {itemDetails.url}</p>}
                </div>

                <h4 className="text-xl font-semibold mb-[15px]">
                  Stock Details
                </h4>
                <p className="mb-2.5">
                  Current Stock : {itemDetails.stock_quantity}
                </p>
                <p className="mb-2.5">
                  Stock Type : {(itemDetails.is_code) ? "CUSTOM CODE" : "PHYSICAL GOODS"}
                </p>

                {itemDetails.low_stock_alert > 0 && (
                    <p>Low Stock Alert : {itemDetails.low_stock_alert}</p>
                )}

                {itemDetails.search_tag?.length > 0 && (
                    <>
                      <h4 className="text-xl font-semibold mt-[20px] mb-[5px]">
                        Search Tags
                      </h4>
                      <p className="mb-2.5">{itemDetails.search_tag ?? ""}</p>
                    </>
                )}

                <br/>
                

                {/* Addons Data */}
                {(typeof(addons) === "object") && <>
                  <h4 className="text-xl font-semibold mt-2 mb-[15px]">
                    Addons
                  </h4>


                  {Object.keys(addons).map((val, i)=>(
                    <div className='border rounded-lg shadow mb-6'>
                      <table className='w-full divide-y divide-gray-200'>
                          <thead className='bg-neutral-100'>
                              <tr className='text-left'>
                                  <th colSpan={2} scope="col" className="px-4 py-3">Variant Details # {(i+1)}</th>
                                  <th scope="col" className="px-6 py-3 text-center" style={{borderLeft: "2px solid #FFF", width: "150px"}}>Type</th>
                              </tr>
                          </thead>
                          <tbody className='divide-y divide-gray-200' style={{ fontSize: "16px" }}>
                            <tr>
                              <td colSpan={2} className='px-4 py-2 border-r-2' style={{ borderRight: "2px solid #e5e7eb" }}>
                                <strong>{addons[val]["name"] ?? "-"}</strong>
                              </td>

                              <td className='text-center px-4 py-2'>
                                {addons[val]["is_required"] ? 
                                <span className="bg-[#E5F9EA] text-[#009E22] ml-1 -mr-1 px-2 py-1 h-6 text-[10px] mt-4 font-medium rounded-3xl">Required</span>: 
                                <span className="bg-[#F5F5F5] text-[#000] ml-1 -mr-1 px-2 py-1 h-6 text-[10px] mt-4 font-medium rounded-3xl">Optional</span>}
                              </td>
                            </tr>

                            {addons[val]?.items.map((data, index)=>(
                              <>
                                <tr>
                                  <td className='text-center px-4 py-2 border-r-2' style={{ borderRight: "2px solid #e5e7eb", width: "50px" }}>
                                    <strong>{index+1}</strong>
                                  </td>
                                  <td className='px-4 py-2 border-r-2' style={{ borderRight: "2px solid #e5e7eb" }}>
                                    {data?.name} <strong className="float-right">x {data?.quantity ?? "-"}</strong>
                                  </td>
                                  <td className='text-center px-4 py-2'>
                                    {process.env.REACT_APP_CURRENCY_SYMBOL} {data.unit_price ?? "-"}
                                  </td>
                                </tr>

                                {(data?.images) && 
                                <>
                                    <tr>
                                      <td className='px-2 py-2' colSpan={3}>
                                        <div className="flex gap-1">
                                        {Object.keys(JSON.parse(data?.images)).map((addons_image)=>(
                                          <img src={JSON.parse(data?.images)[addons_image]} alt="addons" style={{width: "70px", height: "70px"}} />
                                        ))}
                                        </div>
                                      </td>
                                    </tr>
                                </>
                                }
                              </>
                            ))}
                          </tbody>
                        </table>
                      </div>
                  ))}
                  
                  


                </>}

              </div>
            </div>
            <BlackButton
                name="Add Another Item"
                icon={<PlusIcon/>}
                onClick={() => navigate("/dashboard/store/add-item")}
            />
            {itemDetails.is_publish === false &&
             (userProfile?.user_type === "Super Admin" ||
              userProfile?.user_type === "User") && (
                 <button
                     type="submit"
                     className="w-full text-white bg-[#158560] p-3 mb-4 rounded cursor-pointer hover:bg-brand-dark"
                     id="publish-btn"
                     onClick={() => handlePublish()}
                 >
                   Request to Publish
                 </button>
             )}
          </div>
        </div>
      )}
    </>
  );
};

export default StoreItemsDetails;
